module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shared-fields-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.fieldsToShare), function(field) {
    return _c('div', {
      key: field.name,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "share-field-label"
    }, [_vm._v(_vm._s(field.description))]), _vm._v(" "), _c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline",
      attrs: {
        "id": 'hide-' + field.name
      }
    }, [_vm._v("\n              Share field\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.isShared),
        expression: "field.isShared"
      }],
      attrs: {
        "name": field.name,
        "type": "checkbox"
      },
      domProps: {
        "value": true,
        "checked": Array.isArray(field.isShared) ? _vm._i(field.isShared, true) > -1 : (field.isShared)
      },
      on: {
        "input": function($event) {
          field.sharedReadOnly = false
        },
        "change": function($event) {
          var $$a = field.isShared,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = true,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(field, "isShared", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(field, "isShared", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(field, "isShared", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline",
      attrs: {
        "id": 'hide-' + field.name
      }
    }, [_vm._v("\n              Share as read-only\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.sharedReadOnly),
        expression: "field.sharedReadOnly"
      }],
      attrs: {
        "name": field.name,
        "type": "checkbox",
        "disabled": !field.isShared
      },
      domProps: {
        "value": true,
        "checked": Array.isArray(field.sharedReadOnly) ? _vm._i(field.sharedReadOnly, true) > -1 : (field.sharedReadOnly)
      },
      on: {
        "change": function($event) {
          var $$a = field.sharedReadOnly,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = true,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(field, "sharedReadOnly", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(field, "sharedReadOnly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(field, "sharedReadOnly", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.shareAll()
      }
    }
  }, [_vm._v("Share all")]), _vm._v(" "), _c('button', {
    staticClass: "btn green pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.shareAll(true)
      }
    }
  }, [_vm._v("Share all as read-only")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Select fields to share")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5885ac2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ShareFieldsModal.vue
// module id = 1739
// module chunks = 1